/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var dayjs_min = {exports: {}};

(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",$="Invalid Date",l=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_")},m=function(t,e,n){var r=String(t);return !r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},g={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return (e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return -t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return +(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return {M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},v="en",D={};D[v]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return v;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else {var a=e.name;D[a]=e,i=a;}return !r&&i&&(v=i),i||!r&&v},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=g;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t);}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match(l);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init();},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds();},m.$utils=function(){return O},m.isValid=function(){return !(this.$d.toString()===$)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),$=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},l=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,g="set"+(this.$u?"UTC":"");switch(h){case c:return r?$(1,0):$(31,11);case f:return r?$(1,M):$(0,M+1);case o:var v=this.$locale().weekStart||0,D=(y<v?y+7:y)-v;return $(r?m-D:m+(6-D),M);case a:case d:return l(g+"Hours",0);case u:return l(g+"Minutes",1);case s:return l(g+"Seconds",2);case i:return l(g+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),$=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],l=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[$](l),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d;}else $&&this.$d[$](l);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,$=this;r=Number(r);var l=O.p(h),y=function(t){var e=w($);return O.w(e.date(e.date()+Math.round(t*r)),$)};if(l===f)return this.set(f,this.$M+r);if(l===c)return this.set(c,this.$y+r);if(l===a)return y(1);if(l===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[l]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||$;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},l={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||l[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,$){var l,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,g=this-M,v=O.m(this,M);return v=(l={},l[c]=v/12,l[f]=v,l[h]=v/3,l[o]=(g-m)/6048e5,l[a]=(g-m)/864e5,l[u]=g/n,l[s]=g/e,l[i]=g/t,l)[y]||g,$?v:O.a(v)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])};})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[v],w.Ls=D,w.p={},w}));
}(dayjs_min));

var loadScriptAsync = function (url, callback, opt) {
    return new Promise(function (res, rej) {
        var script = document.createElement('script');
        var opts = opt || {};
        script.type = 'text/javascript';
        if (opts.charset) {
            script.charset = opts.charset;
        }
        if (opts.id) {
            script.id = opts.id;
        }
        script.onload = function () {
            callback && callback();
            res(script);
        };
        script.onerror = function (err) {
            rej(err);
        };
        script.src = url;
        document.body.appendChild(script);
    });
};

/**
 * 获取重定向的页面 url，规则如下：
 * 1. 如果当前页面的 url query 中有 redirect 参数，则返回 redirect 参数的值
 * 2. 如果当前页面位于 /login 路径，则返回 /
 * 3. 如果不匹配上面两种规则，仍返回当前页面的 url
 * @param {String} includeHost 返回的 url 是否包含 host
 * @returns {String}
 */
function getRedirectTarget(includeHost) {
    if (includeHost === void 0) { includeHost = false; }
    var currentUrlSearchParams = new URLSearchParams(location.search.split('?')[1]);
    var redirectTarget = currentUrlSearchParams.get('redirect') || location.pathname === '/login' ? '/' : location.pathname;
    return (includeHost ? location.host : '') + redirectTarget;
}

var config = {
    online: {
        uc_url: 'https://cas.baidu.com/staticv2/dep/common-login/api.js',
        uc_url_unlink: '//cas.baidu.com/staticv2/dep/common-login/api.js',
        uc_logout_url: 'https://cas.baidu.com/?action=logout',
        uc_logout_url_unlink: '//cas.baidu.com/?action=logout',
        passport_url: 'https://passport.baidu.com/passApi/js/uni_login_wrapper.js',
        passport_url_unlink: '//passport.baidu.com/passApi/js/uni_login_wrapper.js',
        passport_logout_url: 'https://passport.baidu.com/?logout',
        passport_logout_url_unlink: '//passport.baidu.com/?logout',
    },
    test: {
        uc_url: 'https://cas-off.baidu.com/staticv2/dep/common-login/qa-api.js',
        uc_url_unlink: '//cas-off.baidu.com/staticv2/dep/common-login/qa-api.js',
        uc_logout_url: 'https://cas-off.baidu.com/?action=logout',
        uc_logout_url_unlink: '//cas-off.baidu.com/?action=logout',
        passport_url: 'https://passport.qatest.baidu.com/passApi/js/uni_login_wrapper.js',
        passport_url_unlink: '//passport.qatest.baidu.com/passApi/js/uni_login_wrapper.js',
        passport_logout_url: 'https://passport.qatest.baidu.com/?logout',
        passport_logout_url_unlink: '//passport.qatest.baidu.com/?logout',
    },
};
/**
 * 初始化统一登录框
 * @param {Boolean} isProd 是否是生产环境
 * @param options ucCommonLogin 的配置项
 * @param passOptions passport 的配置项
 * @doc https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/WWW6pX-lL3/9ltq9MUWZu/30Hmnzo8YDHIJt
 */
var initUcCommonLogin = function (isProd, options, passOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var env, V3_JUMP, _a, _b, appid, _c, product, _d, fromuPath, rest;
    return __generator(this, function (_e) {
        if (window.ucCommonLogin && (options === null || options === void 0 ? void 0 : options.isLayer)) {
            return [2 /*return*/];
        }
        env = isProd ? 'online' : 'test';
        V3_JUMP = "".concat(window.location.protocol, "//").concat(window.location.host, "/v3Jump.html");
        _a = options || {}, _b = _a.appid, appid = _b === void 0 ? 701 : _b, _c = _a.product, product = _c === void 0 ? 'overseadia' : _c, _d = _a.fromuPath, fromuPath = _d === void 0 ? '/nodeapi/uc/login' : _d, rest = __rest(_a, ["appid", "product", "fromuPath", "onFail", "onSuccess", "onRender"]);
        return [2 /*return*/, new Promise(function (res, rej) { return __awaiter(void 0, void 0, void 0, function () {
                var defaultOpts, error_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            defaultOpts = {
                                appid: appid,
                                product: product,
                                multiLogin: 0,
                                defaultLogin: 'uc',
                                isAutoLogin: 0,
                                // 是否浮层
                                isLayer: 0,
                                registerUcLink: "https://u.baidu.com/ucweb/?module=Reguser&controller=reg&appid=701&nexturl=".concat(window.location.origin, "/register'"),
                                staticPage: V3_JUMP,
                                // 如果监听了 success 回调、v3jump 不自动跳转、需要手动处理
                                success: function (opt, e) {
                                    if (options === null || options === void 0 ? void 0 : options.onSuccess) {
                                        options.onSuccess(opt, e);
                                    }
                                    // 如果登录方式是 uc，需要配置登录成功后的跳转地址
                                    if (opt.type === 'uc' && typeof e === 'string') {
                                        // 登录成功后要跳转的地址，此 URL 后端服务需接入 casClient
                                        var fromu = "".concat(window.location.origin).concat(fromuPath, "?redirect=").concat(getRedirectTarget());
                                        var redirectUrlSearchParams = new URLSearchParams(e.split('?')[1]);
                                        redirectUrlSearchParams.set('u', fromu);
                                        window.location.href = e.split('?')[0] + '?' + redirectUrlSearchParams.toString();
                                    }
                                },
                                rendered: function (args) {
                                    if (options === null || options === void 0 ? void 0 : options.onRender) {
                                        options.onRender(args);
                                    }
                                    res(args);
                                },
                                fail: function (opts, errorMsg) {
                                    if (options === null || options === void 0 ? void 0 : options.onFail) {
                                        options.onFail(opts, errorMsg);
                                    }
                                    rej(errorMsg);
                                },
                                // 是否使用 UC 默认样式
                                defaultCss: true,
                                ucTitle: '百度商业账号',
                                passportTitle: '百度账号',
                                // window.passport.use 时传入的 options
                                passUseOptions: {
                                    // UC 默认会传入 tangram: true
                                    // 新传入参数会覆盖 UC 默认传入参数
                                    // 使用 Passport v4 版本
                                    loginVersion: 'v4',
                                    // 是否使用 Passport 默认样式
                                    defaultCss: false,
                                },
                                // new magic.passport.login 时传入的 options
                                passLoginOptions: __assign({ 
                                    // UC 默认会根据其他原有参数传入，
                                    // product, staticPage, loginMerge, hasPlaceholder,
                                    // u, charset, isQuickUser, memberPass, safeFlag, registerLink, hasRegUrl
                                    // 新传入参数会覆盖 UC 默认传入参数
                                    // 短信登录
                                    // sms: 5,
                                    // 默认帐号密码登录
                                    // memberPass: false,
                                    userPwdLogin: 1, product: product, u: "".concat(window.location.origin, "/auth/passport?redirect=").concat(getRedirectTarget()), memberPass: false, forgetLink: 'https://passport.baidu.com/?getpass_index', registerLink: 'https://passport.baidu.com/v2/?reg&tpl=&u=', hasRegUrl: true, staticPage: V3_JUMP }, passOptions),
                                // Passport 登录框下 tip
                                // passTip: 'pt',
                                // UC 登录框下 tip
                                // ucTip: 'ut',
                            };
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, loadScriptAsync(config[env].uc_url)];
                        case 2:
                            _b.sent();
                            (_a = window.ucCommonLogin) === null || _a === void 0 ? void 0 : _a.init(__assign(__assign({}, defaultOpts), rest));
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _b.sent();
                            // eslint-disable-next-line no-console
                            console.log('ucCommonLogin error', error_1);
                            rej(error_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); })];
    });
}); };
/**
 * 展示 ucCommonLogin 登录框（需要自行判断 initUcCommonLogin 方法已经调用成功)
 */
var showUcCommonLoginDialog = function () {
    var _a;
    (_a = window.ucCommonLogin) === null || _a === void 0 ? void 0 : _a.show();
};
/**
 * 展示 ucCommonLogin 登录框，调用时会重新初始化 ucCommonLogin 保证调用安全
 */
var showUcCommonLoginDialogSafely = function (isProd, options, passOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, initUcCommonLogin(isProd, options, passOptions)];
            case 1:
                _b.sent();
                (_a = window.ucCommonLogin) === null || _a === void 0 ? void 0 : _a.show();
                return [2 /*return*/];
        }
    });
}); };
/**
 * 隐藏 ucCommonLogin 登录框 (需要自行判断 initUcCommonLogin 方法已经调用成功)
 */
var hideUcCommonLoginDialog = function () {
    var _a;
    (_a = window.ucCommonLogin) === null || _a === void 0 ? void 0 : _a.hide();
};
/**
 * 隐藏 ucCommonLogin 登录框，调用时会重新初始化 ucCommonLogin 保证调用安全
 */
var hideUcCommonLoginDialogSafely = function (isProd, options, passOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, initUcCommonLogin(isProd, options, passOptions)];
            case 1:
                _b.sent();
                (_a = window.ucCommonLogin) === null || _a === void 0 ? void 0 : _a.hide();
                return [2 /*return*/];
        }
    });
}); };
/**
 * [Uc 账号退出]
 * @param isProd 是否是生产环境
 * @param fromu fromu 操作成功回调地址
 */
var logoutUc = function (isProd, fromu) {
    if (fromu === void 0) { fromu = window.location.href; }
    var env = isProd ? 'online' : 'test';
    window.location.href = "".concat(config[env].uc_logout_url_unlink, "&u=").concat(fromu);
};
/**
 * [UC 账号退出]并清除 SAAS 信息
 * @param isProd 是否是生产环境
 * @param fromu fromu 操作成功回调地址
 */
var logoutUcAndSaas = function (isProd, fromu) {
    if (fromu === void 0) { fromu = window.location.href; }
    var env = isProd ? 'online' : 'test';
    window.location.href = "".concat(window.location.origin, "/nodeapi/uc/logout?redirect=").concat(encodeURIComponent("".concat(config[env].uc_logout_url, "&u=").concat(fromu)));
};
/**
 * [Passport 账号退出]
 * @param isProd 是否是生产环境
 * @param fromu fromu 操作成功回调地址
 */
var logoutPassport = function (isProd, fromu) {
    if (fromu === void 0) { fromu = window.location.href; }
    var env = isProd ? 'online' : 'test';
    window.location.href = "".concat(config[env].passport_logout_url_unlink, "&u=").concat(fromu);
};
/**
 * [SAAS 退出登录] UC 账号
 */
var logoutSaasAndUc = function (isProd, fromu) {
    if (fromu === void 0) { fromu = window.location.href; }
    var env = isProd ? 'online' : 'test';
    window.location.href = "".concat(window.location.origin, "/nodeapi/saas/logout?redirect=").concat(encodeURIComponent("".concat(config[env].uc_logout_url, "&u=").concat(fromu)));
    return;
};
/**
 * [SAAS 退出登录] Passport 账号
 */
var logoutSaasAndPassport = function (isProd, fromu) {
    if (fromu === void 0) { fromu = window.location.href; }
    var env = isProd ? 'online' : 'test';
    window.location.href = "".concat(window.location.origin, "/nodeapi/saas/logout?redirect=").concat(encodeURIComponent("".concat(config[env].passport_logout_url, "&u=").concat(fromu)));
    return;
};

export { config, hideUcCommonLoginDialog, hideUcCommonLoginDialogSafely, initUcCommonLogin, logoutPassport, logoutSaasAndPassport, logoutSaasAndUc, logoutUc, logoutUcAndSaas, showUcCommonLoginDialog, showUcCommonLoginDialogSafely };
